var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0 0.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Dark_Blue",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0 -0.1)",
    fill: "#1da1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo__x2014__FIXED",
    d: "M123.646,169.444c10.627,0,16.438-8.806,16.438-16.438,0-.252,0-.5-.012-.743a11.836,11.836,0,0,0,2.887-3,11.725,11.725,0,0,1-3.319.911,5.774,5.774,0,0,0,2.54-3.2,11.7,11.7,0,0,1-3.666,1.4,5.781,5.781,0,0,0-9.992,3.954,5.3,5.3,0,0,0,.156,1.318,16.389,16.389,0,0,1-11.909-6.038,5.774,5.774,0,0,0,1.8,7.7,5.675,5.675,0,0,1-2.612-.719v.072a5.784,5.784,0,0,0,4.637,5.667,5.759,5.759,0,0,1-1.522.2,5.516,5.516,0,0,1-1.09-.108,5.768,5.768,0,0,0,5.391,4.014,11.613,11.613,0,0,1-7.177,2.468,10.508,10.508,0,0,1-1.378-.084,16.1,16.1,0,0,0,8.83,2.612",
    transform: "translate(-104.069 -132.866)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.432c13becb1b5b7757b2db59235500a9.svg";
export { ForwardRef as ReactComponent };